import { BookOpenText, Files, Home, LibraryBig, MessageSquareText, Search } from "lucide-react";
import { NavLink } from "react-router-dom";
import { ThemeSwitcher } from "./ThemeSwitcher";

const items = [
  { to: "/", label: "Главная", icon: Home, end: true },
  { to: "/passport", label: "Паспорт проекта", icon: BookOpenText },
  { to: "/facts", label: "Подтверждённые факты", icon: LibraryBig },
  { to: "/wording", label: "Формулировки", icon: MessageSquareText },
  { to: "/assets", label: "Бренд-материалы", icon: Files },
  { to: "/search", label: "Поиск по базе", icon: Search },
];

export function DesktopSidebar() {
  return (
    <aside className="sidebar">
      <NavLink to="/" className="brand-lockup" aria-label="Social Knowledge Hub — на главную">
        <span className="brand-lockup__mark">
          <img src="/assets/social-logo-white.svg" alt="Social" />
        </span>
        <span>
          <strong>Knowledge Hub</strong>
          <small>by AKFA</small>
        </span>
      </NavLink>
      <nav className="sidebar__nav" aria-label="Основная навигация">
        {items.map(({ to, label, icon: Icon, end }) => (
          <NavLink key={to} to={to} end={end} className={({ isActive }) => `sidebar__link ${isActive ? "is-active" : ""}`}>
            <Icon size={20} strokeWidth={1.8} aria-hidden="true" />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>
      <ThemeSwitcher variant="sidebar" />
      <div className="sidebar__notice">
        <span className="status-dot" />
        <div>
          <strong>Внутренний ресурс</strong>
          <small>Актуально на 15 июля 2026</small>
        </div>
      </div>
    </aside>
  );
}
